const DEFAULT_MAX_WIDTH = 600;
const DEFAULT_MAX_HEIGHT = 300;
const DEFAULT_QUALITY = 0.82;

const readFileAsDataUrl = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

const loadImage = (dataUrl) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = reject;
    image.src = dataUrl;
  });

const canvasToBlob = (canvas, mimeType, quality) =>
  new Promise((resolve) => {
    if (!canvas.toBlob) {
      const dataUrl = canvas.toDataURL(mimeType, quality);
      const byteString = atob(dataUrl.split(",")[1]);
      const arrayBuffer = new ArrayBuffer(byteString.length);
      const intArray = new Uint8Array(arrayBuffer);

      for (let index = 0; index < byteString.length; index += 1) {
        intArray[index] = byteString.charCodeAt(index);
      }

      resolve(new Blob([arrayBuffer], { type: mimeType }));
      return;
    }

    canvas.toBlob(resolve, mimeType, quality);
  });

const blobToDataUrl = (blob) => readFileAsDataUrl(blob);

const getOutputType = () => "image/png";

export const getImageDataUrl = (source) => {
  if (!source) {
    return "";
  }

  if (source.startsWith("data:image/")) {
    return source;
  }

  const mimeType = source.startsWith("/9j/") ? "image/jpeg" : "image/png";
  return `data:${mimeType};base64,${source}`;
};

export const resizeImageForStorage = async (
  file,
  {
    maxWidth = DEFAULT_MAX_WIDTH,
    maxHeight = DEFAULT_MAX_HEIGHT,
    quality = DEFAULT_QUALITY,
  } = {},
) => {
  if (!file) {
    return null;
  }

  const originalDataUrl = await readFileAsDataUrl(file);

  if (file.type === "image/svg+xml") {
    return {
      dataUrl: originalDataUrl,
      base64: originalDataUrl.split(",")[1] || "",
    };
  }

  const image = await loadImage(originalDataUrl);
  const scale = Math.min(maxWidth / image.width, maxHeight / image.height, 1);
  const width = Math.max(1, Math.round(image.width * scale));
  const height = Math.max(1, Math.round(image.height * scale));

  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;

  const context = canvas.getContext("2d");
  context.drawImage(image, 0, 0, width, height);

  const mimeType = getOutputType(file);
  const blob = await canvasToBlob(canvas, mimeType, quality);
  const dataUrl = await blobToDataUrl(blob);

  return {
    dataUrl,
    base64: dataUrl.split(",")[1] || "",
  };
};
